<template>
  <div>
    <div style="text-align: center" class="pb-2">
      <div style="color: #293340; font-weight: 700; font-size: 28px"
        >Tính năng</div
      >
      <div style="color: #959aa9; font-size: 16px"
        >Quản lý bộ dữ liệu, lớp và bản đồ</div
      >
    </div>
    <div class="d-flex justify-space-around mt-4 flex-wrap">
      <div
        class="mt-6 home-card"
        v-for="(item, index) in tinhNangs"
        :key="index"
        :style="{ background: item.bgTop }"
      >
        <div
          style="height: 205px;"
          class="d-flex align-center justify-center"
        >
          <img :src="item.image" />
        </div>
        <div
          :style="{ background: item.bgBottom }"
          class="d-flex flex-column align-center justify-center bottom-card"
        >
          <div style="font-size: 20px; font-weight: 600">{{ item.name }}</div>
          <div style="max-width: 215px; text-align: center">{{
            item.subName
          }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wmsPic from '@assets/images/wms.svg'
import wfsPic from '@assets/images/wfs.svg'
import webCachePic from '@assets/images/webcache.svg'
export default {
  data: () => ({
    tinhNangs: [
      {
        name: 'Web Feature Service',
        subName: 'Cung cấp dịch vụ WFS',
        image: wfsPic,
        bgTop: '#E9F2F3',
        bgBottom: '#57AA48',
      },
      {
        name: 'Web Map Service',
        subName: 'Cung cấp dịch vụ WMS',
        image: wmsPic,
        bgTop: '#EFE9F3',
        bgBottom: '#E2C447',
      },
      {
        name: 'Web cache',
        subName: 'Hỗ trợ dữ liệu bộ nhớ đệm tăng tốc độ truy cập',
        image: webCachePic,
        bgTop: '#FFE6DB',
        bgBottom: '#FFBE9D',
      },
    ],
  }),
}
</script>


<style scoped>
.bottom-card {
  height: 105px;
  border-bottom-left-radius: 19px;
  border-bottom-right-radius: 19px;
}
.home-card {
border-radius: 19px;
width: 400px;
}
</style>